import React from 'react'
import userHasPrivs from 'Helper/Auth/userHasPrivs'
import { push } from 'Helper/routeHelpers'
import DashboardMenu from 'GeneralUI/DashboardMenu/DashboardMenu.jsx'
import { getExporterMenu } from './AppConfig/DataImporters/Exporters/Exporter'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import globalConfig from 'Helper/configHelpers'

class ConfigMenu extends React.PureComponent {
  clickDosingPlan = e => {
    e.preventDefault()
    push('config/dosing_plans')
  }
  clickLobbyDashboard = e => {
    e.preventDefault()
    push('config/lobby/dashboard')
  }
  clickLobbyLogin = e => {
    e.preventDefault()
    push('config/lobby/login')
  }
  clickProviders = e => {
    e.preventDefault()
    push('config/providers')
  }
  clickPrinterTemplates = e => {
    e.preventDefault()
    push('config/general/printer_templates')
  }
  clickTextSummary = e => {
    e.preventDefault()
    push('config/general/text_summary')
  }
  clickReportImages = e => {
    e.preventDefault()
    push('config/general/report_images')
  }
  clickPrintDialogs = e => {
    e.preventDefault()
    push('config/general/print_dialogs')
  }
  clickInventoryLocations = e => {
    e.preventDefault()
    push('config/general/inventory_locations')
  }
  clickPurchaseOrderStatuses = e => {
    e.preventDefault()
    push('config/general/purchase_order_statuses')
  }
  clickTreatmentSetStatuses = e => {
    e.preventDefault()
    push('config/general/treatment_set_statuses')
  }
  clickSkintestStatuses = e => {
    e.preventDefault()
    push('config/general/skintest_statuses')
  }
  clickAccountStatuses = e => {
    e.preventDefault()
    push('config/general/account_statuses')
  }
  clickAttachmentTags = e => {
    e.preventDefault()
    push('config/general/attachment_tags')
  }
  clickVialSizes = e => {
    e.preventDefault()
    push('config/general/vial_sizes')
  }
  clickGlobalSettings = e => {
    e.preventDefault()
    push('config/general/global_settings')
  }
  clickUserPrivileges = e => {
    e.preventDefault()
    push('config/sysadmin/user_privileges')
  }
  clickAdminSysOverview = e => {
    e.preventDefault()
    push('config/sysadmin/system_overview')
  }
  clickSupportFunctions = e => {
    e.preventDefault()
    push('config/sysadmin/support_functions')
  }

  clickOAuthClients = e => {
    e.preventDefault()
    push('config/sysadmin/oauth/clients')
  }

  clickAdminSearchActions = e => {
    e.preventDefault()
    push('config/sysadmin/searchActions')
  }
  clickAdminPharmacyActions = e => {
    e.preventDefault()
    push('config/sysadmin/pharmacyActions')
  }
  clickAdminStateMachineActions = e => {
    e.preventDefault()
    push('config/sysadmin/stateMachineActions')
  }
  clickDataImporters = e => {
    e.preventDefault()
    push('config/sysadmin/data_importers')
  }
  clickCustomerExport = e => {
    e.preventDefault()
    push('config/sysadmin/customer_export')
  }
  clickAdminQuickAccess = e => {
    e.preventDefault()
    push('config/sysadmin/quickAccess')
  }
  clickAdminAdminWindows = e => {
    e.preventDefault()
    push('config/sysadmin/windows/admin')
  }
  clickAdminPatientWindows = e => {
    e.preventDefault()
    push('config/sysadmin/windows/patient')
  }
  clickAdminDashboardScreens = e => {
    e.preventDefault()
    push('config/sysadmin/screens/dashboard')
  }
  clickAdminAdminScreens = e => {
    e.preventDefault()
    push('config/sysadmin/screens/admin')
  }
  clickAdminPatientScreens = e => {
    e.preventDefault()
    push('config/sysadmin/screens/patient')
  }
  clickAdminDashboardWindows = e => {
    e.preventDefault()
    push('config/sysadmin/windows/dashboard')
  }
  clickAdminPatientWorkflows = e => {
    e.preventDefault()
    push('config/sysadmin/workflows/patient')
  }
  clickAdminAdminWorkflows = e => {
    e.preventDefault()
    push('config/sysadmin/workflows/admin')
  }
  clickPatientScreenConfig = e => {
    e.preventDefault()
    push('config/sysadmin/patient_display')
  }
  clickModalConfig = e => {
    e.preventDefault()
    push('config/sysadmin/modal')
  }
  clickFeatureFlags = e => {
    e.preventDefault()
    push('config/sysadmin/feature_flags')
  }
  clickInstallConfigs = e => {
    e.preventDefault()
    push('config/sysadmin/install_configs')
  }
  showConfigMenus = () => {
    const viewSysAdminMenu = userHasPrivs('sys_admin')

    return (
      <div className="config-menu">
        <div className="menu-row">
          <ul className="nav nav-tabs">
            <li role="presentation" className="dropdown">
              <a
                className="dropdown-toggle"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
                aria-labelledby="Injection settings menu"
                data-cy="injectionDropdown"
              >
                <FontAwesomeIcon icon={['fas', 'syringe']} /> Injection{' '}
                <span className="caret" />
              </a>
              <ul className="dropdown-menu">
                <li>
                  <a
                    role="button"
                    aria-labelledby="dosing plans link"
                    data-cy="dosing-plans"
                    onClick={this.clickDosingPlan}
                  >
                    Dosing plans
                  </a>
                </li>
              </ul>
            </li>
            <li role="presentation">
              <a
                className="dropdown-toggle"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
                aria-labelledby="Injection settings menu"
              >
                <FontAwesomeIcon icon={['fas', 'tv']} /> Lobby
                <span className="caret" />
              </a>
              <ul className="dropdown-menu">
                <li>
                  <a
                    role="button"
                    aria-labelledby="lobby login settings"
                    onClick={this.clickLobbyLogin}
                  >
                    <FontAwesomeIcon icon={['fas', 'sign-in-alt']} /> Login
                    settings
                  </a>
                </li>
                <li>
                  <a
                    role="button"
                    aria-labelledby="lobby login settings"
                    onClick={this.clickLobbyDashboard}
                  >
                    <FontAwesomeIcon icon={['fas', 'tv']} /> Dashboard settings
                  </a>
                </li>
              </ul>
            </li>
            <li role="presentation" className="dropdown">
              <a
                className="dropdown-toggle"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
                aria-labelledby="General settings menu"
                data-cy="General-settings"
              >
                <FontAwesomeIcon icon={['fas', 'cog']} /> General{' '}
                <span className="caret" />
              </a>
              <ul className="dropdown-menu">
                <li>
                  <a role="button" onClick={this.clickGlobalSettings}>
                    <FontAwesomeIcon
                      icon={['far', 'sliders-v-square']}
                      aria-labelledby="global settings"
                      aria-hidden="true"
                    />{' '}
                    Global Settings
                  </a>
                </li>
                <li>
                  <a role="button" onClick={this.clickPrinterTemplates}>
                    <FontAwesomeIcon
                      icon={['fas', 'print']}
                      aria-labelledby="printers and templates"
                      aria-hidden="true"
                    />{' '}
                    Printers & Templates
                  </a>
                </li>
                <li>
                  <a role="button" onClick={this.clickReportImages}>
                    <FontAwesomeIcon
                      icon={['fas', 'images']}
                      aria-labelledby="report images"
                      aria-hidden="true"
                    />{' '}
                    Report Images
                  </a>
                </li>
                <li>
                  <a role="button" onClick={this.clickPrintDialogs}>
                    <FontAwesomeIcon
                      icon={['fas', 'columns']}
                      aria-labelledby="print dialogs"
                      aria-hidden="true"
                    />{' '}
                    Print Dialogs
                  </a>
                </li>
                <li>
                  <a role="button" onClick={this.clickTextSummary}>
                    <FontAwesomeIcon
                      icon={['far', 'copy']}
                      aria-labelledby="text summary settings"
                      aria-hidden="true"
                    />{' '}
                    Text Summary
                  </a>
                </li>
                <li>
                  <a role="button" onClick={this.clickInventoryLocations}>
                    <FontAwesomeIcon
                      icon={['fas', 'building']}
                      aria-labelledby="inventory locations"
                      aria-hidden="true"
                    />{' '}
                    Inventory Locations
                  </a>
                </li>
                <li className="dropdown-submenu">
                  <a role="button">
                    <FontAwesomeIcon
                      icon={['fas', 'traffic-light']}
                      aria-labelledby="statuses"
                      aria-hidden="true"
                    />{' '}
                    Status Settings
                  </a>
                  <ul
                    className="dropdown-menu dropdown-menu-right"
                    aria-labelledby="windowsDropDown"
                  >
                    <li>
                      <a
                        role="button"
                        aria-labelledby="admin window config link"
                        onClick={this.clickAccountStatuses}
                      >
                        Account Statuses
                      </a>
                      <a
                        role="button"
                        aria-labelledby="patient window config link"
                        onClick={this.clickPurchaseOrderStatuses}
                      >
                        Purchase Order Statuses
                      </a>
                      <a
                        role="button"
                        aria-labelledby="dashboard window config link"
                        onClick={this.clickTreatmentSetStatuses}
                      >
                        Treatment Set Statuses
                      </a>
                      <a
                        role="button"
                        aria-labelledby="admin window config link"
                        onClick={this.clickSkintestStatuses}
                      >
                        Skintest Statuses
                      </a>
                    </li>
                  </ul>
                </li>
                  <li>
                    <a role="button" onClick={this.clickAttachmentTags}>
                      <FontAwesomeIcon
                        icon={['fas', 'tag']}
                        aria-labelledby="attachment tag settings"
                        aria-hidden="true"
                      />{' '}
                      Attachment Tags
                    </a>
                  </li>
                <li>
                  <a role="button" onClick={this.clickVialSizes}>
                    <FontAwesomeIcon
                      icon={['fas', 'vials']}
                      aria-labelledby="vial size settings"
                      aria-hidden="true"
                    />{' '}
                    Vial Sizes
                  </a>
                </li>
              </ul>
            </li>
            {viewSysAdminMenu ? this.showSysAdminMenu() : null}
          </ul>
        </div>
      </div>
    )
  }
  showSysAdminMenu = () => {
    return (
      <li role="presentation" className="dropdown">
        <a
          className="dropdown-toggle"
          data-toggle="dropdown"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
          aria-labelledby="system admin menu"
        >
          <FontAwesomeIcon icon={['fas', 'wrench']} /> System Admin.{' '}
          <span className="caret" />
        </a>
        <ul className="dropdown-menu">
          <li>
            <a
              role="button"
              aria-labelledby="System overview link"
              onClick={this.clickAdminSysOverview}
            >
              <FontAwesomeIcon icon={['far', 'info-square']} /> System overview
            </a>
          </li>
          <li>
            <a role="button" onClick={this.clickSupportFunctions}>
              <FontAwesomeIcon
                icon={['fas', 'tools']}
                aria-labelledby="support function"
                aria-hidden="true"
              />{' '}
              Support Functions
            </a>
          </li>
          <li>
            <a role="button" onClick={this.clickOAuthClients}>
              <FontAwesomeIcon
                icon={['fas', 'user-astronaut']}
                aria-labelledby="support function"
                aria-hidden="true"
              />{' '}
              OAuth Clients
            </a>
          </li>
          <li>
            <a
              role="button"
              aria-labelledby="data import link"
              onClick={this.clickDataImporters}
            >
              <FontAwesomeIcon icon={['fas', 'file-import']} /> Data import
            </a>
          </li>
          <li>
            <a
              role="button"
              aria-labelledby="customer export link"
              onClick={this.clickCustomerExport}
            >
              <FontAwesomeIcon icon={['fas', 'file-export']} /> Customer export
            </a>
          </li>
          <li className="dropdown-submenu">
            <a
              className="dropdown-toggle"
              id="exportersDropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
              role="button"
              aria-labelledby="data export menu"
            >
              <FontAwesomeIcon icon={['fas', 'file-export']} /> Data export
            </a>
            <ul
              className="dropdown-menu dropdown-menu-right"
              aria-labelledby="exportersDropdown"
            >
              {getExporterMenu().map((submenu, idx) => {
                return (
                  <li key={idx}>
                    <a
                      role="button"
                      aria-labelledby={`export ${submenu.name} download link`}
                      onClick={submenu.getExport}
                    >
                      Download {submenu.name} CSV
                    </a>
                  </li>
                )
              })}
            </ul>
          </li>
          <li>
            <a
              role="button"
              aria-labelledby="search config link"
              onClick={this.clickAdminSearchActions}
            >
              <FontAwesomeIcon icon={['fas', 'search']} /> Search config
            </a>
          </li>
          <li>
            <a
              role="button"
              aria-labelledby="pharmacy config link"
              onClick={this.clickAdminPharmacyActions}
            >
              <FontAwesomeIcon icon={['fas', 'truck']} /> Pharmacies
            </a>
          </li>
          <li>
            <a
              role="button"
              aria-labelledby="state machine config link"
              onClick={this.clickAdminStateMachineActions}
            >
              <FontAwesomeIcon icon={['fas', 'cogs']} /> State Machines
            </a>
          </li>
          <li>
            <a
              role="button"
              aria-labelledby="patient screen config"
              onClick={this.clickPatientScreenConfig}
            >
              <FontAwesomeIcon icon={['fas', 'user-astronaut']} /> Patient
              screen config
            </a>
          </li>
          <li>
            <a
              role="button"
              aria-labelledby="quick access config link"
              onClick={this.clickAdminQuickAccess}
            >
              <FontAwesomeIcon icon={['fas', 'universal-access']} /> Quick
              access config
            </a>
          </li>
          <li>
            <a
              role="button"
              aria-labelledby="User privileges link"
              onClick={this.clickUserPrivileges}
            >
              <FontAwesomeIcon icon={['far', 'user-lock']} /> User Privileges
            </a>
          </li>
          <li>
            <a
              role="button"
              aria-labelledby="modal config"
              onClick={this.clickFeatureFlags}
            >
              <FontAwesomeIcon icon={['fas', 'exclamation-square']} /> Feature flags
            </a>
          </li>
          <li>
            <a
              role="button"
              aria-labelledby="modal config"
              onClick={this.clickInstallConfigs}
            >
              <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} /> Install
              configs
            </a>
          </li>
          <li>
            <a
              role="button"
              aria-labelledby="modal config"
              onClick={this.clickModalConfig}
            >
              <FontAwesomeIcon icon={['far', 'comment-alt']} /> Modal config
            </a>
          </li>
          <li className="dropdown-submenu">
            <a
              className="dropdown-toggle"
              id="windowsDropDown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
              role="button"
              aria-labelledby="windows submenu"
            >
              <FontAwesomeIcon icon={['far', 'window-maximize']} /> Windows
            </a>
            <ul
              className="dropdown-menu dropdown-menu-right"
              aria-labelledby="windowsDropDown"
            >
              <li>
                <a
                  role="button"
                  aria-labelledby="patient window config link"
                  onClick={this.clickAdminPatientWindows}
                >
                  Patient windows
                </a>
                <a
                  role="button"
                  aria-labelledby="dashboard window config link"
                  onClick={this.clickAdminDashboardWindows}
                >
                  Dashboard windows
                </a>
                <a
                  role="button"
                  aria-labelledby="system management window config link"
                  onClick={this.clickAdminAdminWindows}
                >
                  System windows
                </a>
              </li>
            </ul>
          </li>
          <li className="dropdown-submenu">
            <a
              className="dropdown-toggle"
              id="screensDropDown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
              role="button"
              aria-labelledby="screens submenu"
            >
              <FontAwesomeIcon icon={['far', 'window-restore']} /> Screens
            </a>
            <ul
              className="dropdown-menu dropdown-menu-right"
              aria-labelledby="windowsDropDown"
            >
              <li>
                <a
                  role="button"
                  aria-labelledby="patient screens config link"
                  onClick={this.clickAdminPatientScreens}
                >
                  Patient screens
                </a>
                <a
                  role="button"
                  aria-labelledby="dashboard screens config link"
                  onClick={this.clickAdminDashboardScreens}
                >
                  Dashboard screens
                </a>
                <a
                  role="button"
                  aria-labelledby="system management screens config link"
                  onClick={this.clickAdminAdminScreens}
                >
                  System screens
                </a>
              </li>
            </ul>
          </li>
          <li className="dropdown-submenu">
            <a
              className="dropdown-toggle"
              id="workflowsDropDown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
              role="button"
              aria-labelledby="workflows submenu"
            >
              <FontAwesomeIcon icon={['far', 'step-forward']} /> Workflows
            </a>
            <ul
              className="dropdown-menu dropdown-menu-right"
              aria-labelledby="workflowsDropDown"
            >
              <li>
                <a
                  role="button"
                  aria-labelledby="patient workflow config link"
                  onClick={this.clickAdminPatientWorkflows}
                >
                  Patient workflows
                </a>
                <a
                  role="button"
                  aria-labelledby="system management workflow config link"
                  onClick={this.clickAdminAdminWorkflows}
                >
                  System workflows
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    )
  }

  render() {
    return (
      <DashboardMenu
        allowPatientSearch={false}
        additionalContent={this.showConfigMenus}
      />
    )
  }
}

export default ConfigMenu
